/* Katlanır sipariş özeti — chevron toplam satırının kendisinde.

   Neden düz <details> değil: kapalıyken üstü çizili ara toplamı gösterip
   açıkken gizlemek ve erişilebilir eylem adını ("Show/Hide order details")
   duruma göre değiştirmek gerekiyor. <details> ikisini de vermiyor.

   Drawer her adet değişiminde Section Rendering API ile YENİDEN kuruluyor,
   yani bu element yok edilip baştan yaratılıyor. Açık/kapalı durum bu yüzden
   modül kapsamında tutuluyor — yoksa kullanıcı özeti açıp adet değiştirince
   panel sessizce kapanırdı. */

let expanded = false;

class CartSummaryFold extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-summary-toggle]');
    this.detail = this.querySelector('.aycan-cart-summary__detail');
    this.hint = this.querySelector('[data-summary-hint]');
    if (!this.toggle || !this.detail) return;

    this.apply();

    /* connectedCallback element DOM'a her eklendiğinde çalışır; drawer açılıp
       kapanırken bu birden fazla kez oluyor. Guard olmadan ikinci bir dinleyici
       bağlanıyor ve tek tıklama durumu İKİ kez çevirdiği için panel hiç açılmıyordu
       (canlıda ölçüldü). Aynı guard deseni `aycan-cart-promo.js`'te de var. */
    if (this._bound) return;
    this._bound = true;

    this.toggle.addEventListener('click', () => {
      expanded = !expanded;
      this.apply();
    });
  }

  apply() {
    this.toggle.setAttribute('aria-expanded', String(expanded));
    this.detail.hidden = !expanded;
    if (this.hint) {
      const key = expanded ? 'labelHide' : 'labelShow';
      this.hint.textContent = this.dataset[key] || '';
    }
  }
}

if (!customElements.get('cart-summary-fold')) {
  customElements.define('cart-summary-fold', CartSummaryFold);
}
